/**
 * List of countries with the country codes.
 * This list has been imported manually, and it's not supposed to change often.
 *
 * @see countries_version1.csv file (obtained from dotcom)
 */
const diallingCodes = {
  AF: {
    diallingCode: '93'
  },
  AX: {
    diallingCode: '358'
  },
  AL: {
    diallingCode: '355'
  },
  DZ: {
    diallingCode: '213'
  },
  AS: {
    diallingCode: '1'
  },
  AD: {
    diallingCode: '376'
  },
  AO: {
    diallingCode: '244'
  },
  AI: {
    diallingCode: '1'
  },
  AG: {
    diallingCode: '268'
  },
  AR: {
    diallingCode: '54'
  },
  AM: {
    diallingCode: '374'
  },
  AW: {
    diallingCode: '297'
  },
  AU: {
    diallingCode: '61'
  },
  AT: {
    diallingCode: '43'
  },
  AZ: {
    diallingCode: '994'
  },
  BS: {
    diallingCode: '242'
  },
  BH: {
    diallingCode: '973'
  },
  BD: {
    diallingCode: '880'
  },
  BB: {
    diallingCode: '246'
  },
  BY: {
    diallingCode: '375'
  },
  BE: {
    diallingCode: '32'
  },
  BZ: {
    diallingCode: '501'
  },
  BJ: {
    diallingCode: '229'
  },
  BM: {
    diallingCode: '441'
  },
  BT: {
    diallingCode: '975'
  },
  BO: {
    diallingCode: '591'
  },
  BA: {
    diallingCode: '387'
  },
  BW: {
    diallingCode: '267'
  },
  BV: {
    diallingCode: '47'
  },
  BR: {
    diallingCode: '55'
  },
  VG: {
    diallingCode: '1'
  },
  BN: {
    diallingCode: '673'
  },
  BG: {
    diallingCode: '359'
  },
  BF: {
    diallingCode: '226'
  },
  BI: {
    diallingCode: '257'
  },
  KH: {
    diallingCode: '855'
  },
  CM: {
    diallingCode: '237'
  },
  CA: {
    diallingCode: '1'
  },
  CV: {
    diallingCode: '238'
  },
  KY: {
    diallingCode: '345'
  },
  CF: {
    diallingCode: '236'
  },
  TD: {
    diallingCode: '235'
  },
  CL: {
    diallingCode: '56'
  },
  CN: {
    diallingCode: '86'
  },
  CX: {
    diallingCode: '61'
  },
  CC: {
    diallingCode: '891'
  },
  CO: {
    diallingCode: '57'
  },
  KM: {
    diallingCode: '269'
  },
  CG: {
    diallingCode: '242'
  },
  CD: {
    diallingCode: '243'
  },
  CK: {
    diallingCode: '682'
  },
  CR: {
    diallingCode: '506'
  },
  HR: {
    diallingCode: '385'
  },
  CU: {
    diallingCode: '53'
  },
  CW: {
    diallingCode: '599'
  },
  CY: {
    diallingCode: '357'
  },
  CZ: {
    diallingCode: '420'
  },
  DK: {
    diallingCode: '45'
  },
  DJ: {
    diallingCode: '253'
  },
  DM: {
    diallingCode: '767'
  },
  DO: {
    diallingCode: '1'
  },
  EC: {
    diallingCode: '593'
  },
  EG: {
    diallingCode: '20'
  },
  SV: {
    diallingCode: '503'
  },
  GQ: {
    diallingCode: '240'
  },
  ER: {
    diallingCode: '291'
  },
  EE: {
    diallingCode: '372'
  },
  ET: {
    diallingCode: '251'
  },
  FK: {
    diallingCode: '500'
  },
  FO: {
    diallingCode: '298'
  },
  FJ: {
    diallingCode: '679'
  },
  FI: {
    diallingCode: '358'
  },
  FR: {
    diallingCode: '33'
  },
  GF: {
    diallingCode: '594'
  },
  PF: {
    diallingCode: '689'
  },
  GA: {
    diallingCode: '241'
  },
  GM: {
    diallingCode: '220'
  },
  GE: {
    diallingCode: '995'
  },
  DE: {
    diallingCode: '49'
  },
  GH: {
    diallingCode: '233'
  },
  GI: {
    diallingCode: '350'
  },
  GR: {
    diallingCode: '30'
  },
  GL: {
    diallingCode: '299'
  },
  GD: {
    diallingCode: '473'
  },
  GP: {
    diallingCode: '590'
  },
  GU: {
    diallingCode: '671'
  },
  GT: {
    diallingCode: '502'
  },
  GG: {
    diallingCode: '44'
  },
  GN: {
    diallingCode: '224'
  },
  GW: {
    diallingCode: '245'
  },
  GY: {
    diallingCode: '592'
  },
  HT: {
    diallingCode: '509'
  },
  VA: {
    diallingCode: '379'
  },
  HN: {
    diallingCode: '504'
  },
  HK: {
    diallingCode: '852'
  },
  HU: {
    diallingCode: '36'
  },
  IS: {
    diallingCode: '354'
  },
  IN: {
    diallingCode: '91'
  },
  ID: {
    diallingCode: '62'
  },
  IR: {
    diallingCode: '98'
  },
  IQ: {
    diallingCode: '964'
  },
  IE: {
    diallingCode: '353'
  },
  IM: {
    diallingCode: '44'
  },
  IL: {
    diallingCode: '972'
  },
  IT: {
    diallingCode: '39'
  },
  CI: {
    diallingCode: '225'
  },
  JM: {
    diallingCode: '876'
  },
  JP: {
    diallingCode: '81'
  },
  JE: {
    diallingCode: '44'
  },
  JO: {
    diallingCode: '962'
  },
  KZ: {
    diallingCode: '7'
  },
  KE: {
    diallingCode: '254'
  },
  KI: {
    diallingCode: '686'
  },
  KP: {
    diallingCode: '850'
  },
  KR: {
    diallingCode: '82'
  },
  KW: {
    diallingCode: '965'
  },
  KG: {
    diallingCode: '996'
  },
  LA: {
    diallingCode: '856'
  },
  LV: {
    diallingCode: '371'
  },
  LB: {
    diallingCode: '961'
  },
  LS: {
    diallingCode: '266'
  },
  LR: {
    diallingCode: '231'
  },
  LY: {
    diallingCode: '218'
  },
  LI: {
    diallingCode: '423'
  },
  LT: {
    diallingCode: '370'
  },
  LU: {
    diallingCode: '352'
  },
  MO: {
    diallingCode: '853'
  },
  MK: {
    diallingCode: '389'
  },
  MG: {
    diallingCode: '261'
  },
  MW: {
    diallingCode: '265'
  },
  MY: {
    diallingCode: '60'
  },
  MV: {
    diallingCode: '960'
  },
  ML: {
    diallingCode: '223'
  },
  MT: {
    diallingCode: '356'
  },
  MH: {
    diallingCode: '692'
  },
  MQ: {
    diallingCode: '596'
  },
  MR: {
    diallingCode: '222'
  },
  MU: {
    diallingCode: '230'
  },
  YT: {
    diallingCode: '262'
  },
  MX: {
    diallingCode: '52'
  },
  FM: {
    diallingCode: '691'
  },
  MD: {
    diallingCode: '373'
  },
  MC: {
    diallingCode: '377'
  },
  MN: {
    diallingCode: '976'
  },
  ME: {
    diallingCode: '382'
  },
  MS: {
    diallingCode: '1'
  },
  MA: {
    diallingCode: '212'
  },
  MZ: {
    diallingCode: '258'
  },
  MM: {
    diallingCode: '95'
  },
  NA: {
    diallingCode: '264'
  },
  NR: {
    diallingCode: '674'
  },
  NP: {
    diallingCode: '977'
  },
  NL: {
    diallingCode: '31'
  },
  AN: {
    diallingCode: '599'
  },
  NC: {
    diallingCode: '687'
  },
  NZ: {
    diallingCode: '64'
  },
  NI: {
    diallingCode: '505'
  },
  NE: {
    diallingCode: '227'
  },
  NG: {
    diallingCode: '234'
  },
  NU: {
    diallingCode: '683'
  },
  NF: {
    diallingCode: '672'
  },
  MP: {
    diallingCode: '1'
  },
  NO: {
    diallingCode: '47'
  },
  OM: {
    diallingCode: '968'
  },
  PK: {
    diallingCode: '92'
  },
  PS: {
    diallingCode: '970'
  },
  PA: {
    diallingCode: '507'
  },
  PG: {
    diallingCode: '675'
  },
  PY: {
    diallingCode: '595'
  },
  PE: {
    diallingCode: '51'
  },
  PH: {
    diallingCode: '63'
  },
  PN: {
    diallingCode: '64'
  },
  PL: {
    diallingCode: '48'
  },
  PT: {
    diallingCode: '351'
  },
  PR: {
    diallingCode: '1'
  },
  QA: {
    diallingCode: '974'
  },
  RE: {
    diallingCode: '262'
  },
  RO: {
    diallingCode: '40'
  },
  RU: {
    diallingCode: '7'
  },
  RW: {
    diallingCode: '250'
  },
  BL: {
    diallingCode: '590'
  },
  SH: {
    diallingCode: '290'
  },
  KN: {
    diallingCode: '1'
  },
  LC: {
    diallingCode: '1'
  },
  MF: {
    diallingCode: '590'
  },
  PM: {
    diallingCode: '508'
  },
  VC: {
    diallingCode: '1'
  },
  WS: {
    diallingCode: '685'
  },
  SM: {
    diallingCode: '378'
  },
  ST: {
    diallingCode: '239'
  },
  SA: {
    diallingCode: '966'
  },
  SN: {
    diallingCode: '221'
  },
  RS: {
    diallingCode: '381'
  },
  SC: {
    diallingCode: '248'
  },
  SL: {
    diallingCode: '232'
  },
  SG: {
    diallingCode: '65'
  },
  SK: {
    diallingCode: '421'
  },
  SI: {
    diallingCode: '386'
  },
  SB: {
    diallingCode: '677'
  },
  SO: {
    diallingCode: '252'
  },
  ZA: {
    diallingCode: '27'
  },
  SS: {
    diallingCode: '211'
  },
  ES: {
    diallingCode: '34'
  },
  LK: {
    diallingCode: '94'
  },
  SD: {
    diallingCode: '249'
  },
  SR: {
    diallingCode: '597'
  },
  SZ: {
    diallingCode: '268'
  },
  SE: {
    diallingCode: '46'
  },
  CH: {
    diallingCode: '41'
  },
  SY: {
    diallingCode: '963'
  },
  TW: {
    diallingCode: '886'
  },
  TJ: {
    diallingCode: '992'
  },
  TZ: {
    diallingCode: '255'
  },
  TH: {
    diallingCode: '66'
  },
  TG: {
    diallingCode: '228'
  },
  TK: {
    diallingCode: '690'
  },
  TO: {
    diallingCode: '676'
  },
  TT: {
    diallingCode: '868'
  },
  TN: {
    diallingCode: '216'
  },
  TR: {
    diallingCode: '90'
  },
  TM: {
    diallingCode: '993'
  },
  TC: {
    diallingCode: '1'
  },
  TV: {
    diallingCode: '688'
  },
  UG: {
    diallingCode: '256'
  },
  UA: {
    diallingCode: '380'
  },
  AE: {
    diallingCode: '971'
  },
  GB: {
    diallingCode: '44'
  },
  US: {
    diallingCode: '1'
  },
  VI: {
    diallingCode: '1'
  },
  UY: {
    diallingCode: '598'
  },
  UZ: {
    diallingCode: '998'
  },
  VU: {
    diallingCode: '678'
  },
  VE: {
    diallingCode: '58'
  },
  VN: {
    diallingCode: '84'
  },
  WF: {
    diallingCode: '681'
  },
  EH: {
    diallingCode: '212'
  },
  YE: {
    diallingCode: '967'
  },
  ZM: {
    diallingCode: '260'
  },
  ZW: {
    diallingCode: '263'
  }
};

export default diallingCodes;
